import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default () => ({
  swiper: null,

  init() {
    this.$nextTick(() => {
      const swiperEl = this.$refs.swiper;
      const prevEl = this.$refs.prev;
      const nextEl = this.$refs.next;

      if (!swiperEl || this.swiper) {
        return;
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.08,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        loop: false,
        navigation: {
          prevEl,
          nextEl,
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      });
    });
  },

  destroy() {
    if (!this.swiper) {
      return;
    }

    this.swiper.destroy(true, true);
    this.swiper = null;
  },
});